module.exports = {
    login_credentials_incorrect: "Nesprávne prihlasovacie údaje"
  }